import { ApplicationConfig, importProvidersFrom } from '@angular/core'
import {
  InMemoryScrollingFeature,
  InMemoryScrollingOptions,
  provideRouter,
  withInMemoryScrolling,
  withViewTransitions
} from '@angular/router'
import { provideAnimations } from '@angular/platform-browser/animations';
import { appRoutes } from './app.routes'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { provideAuthModule } from 'auth'
import { StoreDevtoolsModule } from '@ngrx/store-devtools'
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideImgixLoader } from '@angular/common';
import { CLOUDFRONT_URLS } from './contants';
import { errorInterceptor } from './core/errors/error.interceptor';
import { environment } from '../environments/environment';
import { PixelModule } from 'ngx-multi-pixel';

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
};

const inMemoryScrollingFeature: InMemoryScrollingFeature =
  withInMemoryScrolling(scrollConfig);

export const appConfig: ApplicationConfig = {
  providers: [
    provideImgixLoader(CLOUDFRONT_URLS.explorer_v2),
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([errorInterceptor])
    ),
    provideImgixLoader('https://yp-explorer.s3.amazonaws.com/v2/'),
    importProvidersFrom(StoreModule.forRoot({}), EffectsModule.forRoot([])),
    importProvidersFrom(StoreDevtoolsModule.instrument()),
    importProvidersFrom(PixelModule.forRoot({ enabled: true, pixelId: ['2376732922558866'] })),
    //provideStoreDevtools({ maxAge: 25,  logOnly: true}), // logOnly: !isDevMode}), // Retains last 25 states logOnly: !isDevMode()
    provideRouter(
      appRoutes,
      withViewTransitions(),
      inMemoryScrollingFeature,
    ),
    provideAnimations(),
    provideAuthModule({
      environment: environment.name,
      api: environment.api,
      project: environment.project,
      domain: environment.domain,
      logLevel: 'DEBUG',
      redirectLoginUrl: '/dashboard',
      redirectLogoutUrl: '/',
      redirectPetGuardUrl: '/',
      redirectUserGuardUrl: '/login',
      SESSSION_KEYS: {
        user: 'EXPLORE_USER',
        pet: 'EXPLORE_PET',
        token: environment.tokenKey,
        lang: 'EXPLORER_LANG',
        origin: 'EXPLORER_ORIGIN'
      }
    }),
  ]
}
